module.exports = fox._r("images/relate_bad.gif", __webpack_public_path__ + "images/relate_bad.gif");


//////////////////
// WEBPACK FOOTER
// ./images/relate_bad.gif
// module id = 1097
// module chunks = 4